import apiClient from "@/services/apiClient";

export const studentEnrollmentWorkflowService = {
  getWorkflowHistory: async (studentEnrollmentId) => {
    const response = await apiClient.get(`/StudentEnrollment/GetWorkflowHistory/${studentEnrollmentId}`);
    return response.data;
  },
};
